<!-- eslint-disable no-tabs -->
<template>
  <div class="panel-notification">
    <div class="panel-list metrics-group">
      <div class="d-flex" style="justify-content: space-between;">
        <h4 class="mb-15 ml-15 text-lowercase text-md">
          Shipment Details
        </h4>
        <Button type="primary" size="mini" :disabled="disableNextStep" @click="nextStep()">
          <span>NEXT</span>
        </Button>
      </div>
      <ul class="metrics-box panel-grid-list d-flex">
        <li style="width: 50%;">
          <div class="panel-grid-list-header">{{$t('ADMIN_MOVEMENT')}}</div>
          <div class="dropdown-section">
            <Select v-model="workflow.movement_type"
              :placeholder="$t('ADMIN_SELECT')"
              popper-class="dropdowntag">
              <Option
                v-for="item in movements"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </Option>
          </Select>
          </div>
        </li>
        <li style="width: 50%;">
          <div class="panel-grid-list-header">{{$t('INDENT_DELIVERY_TYPE')}}</div>
          <div class="dropdown-section">
            <Select v-model="workflow.delivery_type"
              :placeholder="$t('ADMIN_SELECT')"
              popper-class="dropdowntag">
              <Option
                v-for="item in deliveryTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </Option>
          </Select>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
    },
    isListLoading: {
      type: Boolean,
      default: true,
    },
    workflow: {
      type: Object,
    },
  },
  data() {
    return {
      shipmentData: {
        movement_type: '',
        delivery_type: '',
      },
      movements: [{
        id: 'PRIMARY',
        name: 'Primary',
      }, {
        id: 'SECONDARY',
        name: 'Secondary',
      },
      {
        id: 'VENDOR',
        name: 'Vendor',
      },
      {
        id: 'RETURN',
        name: 'Return',
      }],
      deliveryTypes: [{
        id: 'FTL',
        name: 'FTL',
      }, {
        id: 'PTL',
        name: 'PTL',
      }],
    };
  },
  created() {},
  computed: {
    disableNextStep() {
      return !this.workflow || (!this.workflow.movement_type || !this.workflow.delivery_type);
    },
  },
  methods: {
    nextStep() {
      this.$emit('next-step', this.shipmentData);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@common/styles-shipper/settings";
.panel-notification {
  width: 60%;
}

.panel-notification .metrics-box {
  background-color: rgba(255, 255, 255, 0.75);
  font-size: 1.2rem;
  color: #404040;
  border-bottom: 1px solid #E9F1F5;
  margin-left: 10px;
  margin-top: 10px;
  border-radius: 5px;
}


.metrics-group {
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  padding: 10px;
  display: -ms-flexbox;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  font-size: 1.2rem;
  color: #404040;
  border: 1px solid #E9F1F5;
  margin-bottom: 10px;
}
</style>
